import styled from 'styled-components'

import Button from '@components/atoms/Button'
import Col from '@components/atoms/Grid/Col'
import Headline from '@components/atoms/Headline'
import Text from '@components/atoms/Text'
import Contracts from '@components/molecules/Contracts'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${(props) => props.theme.margin.big};
`
export const TextLink = styled.a`
  font-weight: bold;
`

export const StudioInfo = styled(Col)`
  text-align: center;
  margin: auto;
  p {
    margin: auto;
    margin-bottom: ${(props) => props.theme.margin.default};
  }
`

interface BrandedHeadlineProps {
  color: string
}

export const BrandedHeadline = styled(Headline)<BrandedHeadlineProps>`
  border-bottom: 8px solid ${(props) => props.color};
`
export const StyledContracts = styled(Contracts)`
  margin-bottom: ${(props) => props.theme.margin.big};
`

export const StudioDetailPageHead = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-bottom: ${(props) => props.theme.margin.big};
`

export const StyledHeadText = styled(Text)`
  justify-self: center;
  align-self: center;
  margin: auto;
  margin-top: ${(props) => props.theme.margin.small};
  margin-bottom: ${(props) => props.theme.margin.small};
`

export const CenterCenterCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: ${(props) => props.theme.margin.big};
  align-items: stretch;
  img {
    max-width: 100%;
    height: auto;
  }
`

export const StyledButton = styled(Button)`
  width: auto;
  display: flex;
  margin: 0 auto;
`
export const Center = styled.div`
  text-align: center;
`
